import React from 'react';
import { Link } from 'react-router-dom';
type EmptyStateProps = {
  title: string;
  description: string;
  icon: React.ReactNode;
  actionText?: string;
  actionLink?: string;
  onAction?: () => void;
  secondaryActionText?: string;
  secondaryActionLink?: string;
  onSecondaryAction?: () => void;
};
const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  actionText,
  actionLink,
  onAction,
  secondaryActionText,
  secondaryActionLink,
  onSecondaryAction
}) => {
  return <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-8 text-center flex flex-col items-center justify-center transition-all duration-300 hover:border-gray-400 dark:hover:border-gray-500" data-id="element-95">
      <div className="w-20 h-20 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mb-4 transition-transform duration-300 hover:scale-110" data-id="element-96">
        {icon}
      </div>
      <h3 className="text-lg font-bold mb-2 dark:text-gray-200" data-id="element-97">{title}</h3>
      <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md" data-id="element-98">
        {description}
      </p>
      <div className="flex flex-col sm:flex-row gap-3" data-id="element-99">
        {actionText && (actionLink || onAction) && <>
            {actionLink ? <Link to={actionLink} className="bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-4 py-2 rounded-md transition-all duration-300 hover:bg-gray-700 dark:hover:bg-gray-300 hover:scale-105" data-id="element-100">
                {actionText}
              </Link> : <button onClick={onAction} className="bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 px-4 py-2 rounded-md transition-all duration-300 hover:bg-gray-700 dark:hover:bg-gray-300 hover:scale-105" data-id="element-101">
                {actionText}
              </button>}
          </>}
        {secondaryActionText && (secondaryActionLink || onSecondaryAction) && <>
            {secondaryActionLink ? <Link to={secondaryActionLink} className="border border-gray-300 dark:border-gray-600 px-4 py-2 rounded-md transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105" data-id="element-102">
                {secondaryActionText}
              </Link> : <button onClick={onSecondaryAction} className="border border-gray-300 dark:border-gray-600 px-4 py-2 rounded-md transition-all duration-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:scale-105" data-id="element-103">
                {secondaryActionText}
              </button>}
          </>}
      </div>
    </div>;
};
export default EmptyState;